<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!['read'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{
          (!istodo && formData.hiddenDangerRectificationStatus === 4) || (istodo && isdelay)
            ? '隐患治理延期审核'
            : '隐患治理验收'
        }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="隐患基本信息" name="baseInfo">
            <HiddenInfo :FormData="formData"></HiddenInfo>
          </el-collapse-item>
          <el-collapse-item title="隐患审核" name="verify">
            <HiddenOk :FormData="formData"></HiddenOk>
          </el-collapse-item>
          <el-collapse-item
            title="隐患整改"
            name="rectification"
            v-if="formData.hiddenDangerRectificationStatus !== 0"
          >
            <el-form
              :disabled="disabled"
              ref="form"
              label-width="150px"
              :model="formData"
              v-loading="loading"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    label="整改要求"
                    prop="hiddenDangerOpinionsRectification"
                    ref="hiddenDangerOpinionsRectification"
                    :rules="[
                      {
                        required: true,
                        message: '请输入整改要求',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.hiddenDangerOpinionsRectification"
                      placeholder="请输入整改要求"
                      maxlength="500"
                      show-word-limit
                      type="textarea"
                      :rows="1"
                      clearable
                      :disabled="disabled"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    label="方案负责人"
                    prop="solutionLeaderUserId"
                    ref="solutionLeaderUserId"
                  >
                    <MultiplePersonSelect
                      class="w-full"
                      placeholder="请输入方案负责人"
                      v-model="formData.solutionLeaderUserId"
                      :disabled="disabled"
                    ></MultiplePersonSelect>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    label="开始整改时间"
                    prop="startRectificationTime"
                    ref="startRectificationTime"
                  >
                    <el-date-picker
                      size="small"
                      v-model="formData.startRectificationTime"
                      :disabled="true"
                      type="datetime"
                      class="!w-full"
                      placeholder="请选择开始整改时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="隐患解决方案"
                    prop="hiddenHazardRectificationPlan"
                    ref="hiddenHazardRectificationPlan"
                    :rules="[
                      {
                        required: true,
                        message: '请输入隐患解决方案',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <el-input
                      v-model="formData.hiddenHazardRectificationPlan"
                      placeholder="请输入隐患解决方案"
                      maxlength="500"
                      :show-word-limit="true"
                      type="textarea"
                      :rows="4"
                      clearable
                      :disabled="disabled"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item
                    label="附件"
                    prop="hiddenHazardRectificationAttachments"
                    ref="hiddenHazardRectificationAttachments"
                  >
                    <form-upload
                      :disabled="disabled"
                      :maxSize="200"
                      :limit="1"
                      :accept="[
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'pdf',
                        'doc',
                        'docx',
                        'xls',
                        'xlsx',
                        'txt',
                      ]"
                      v-model="formData.hiddenHazardRectificationAttachments"
                    ></form-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="整改后图片"
                    prop="photosAfterRectification"
                    ref="photosAfterRectification"
                    :rules="[
                      {
                        required: true,
                        message: '请输入整改后图片',
                        trigger: ['blur', 'change'],
                      },
                    ]"
                  >
                    <img-upload
                      v-model="formData.photosAfterRectification"
                      :upload-width="120"
                      :upload-height="120"
                      :maxSize="20"
                      :limit="5"
                      :isDisabledUploadComponent="disabled"
                      :isShowDeleteButton="!disabled"
                    ></img-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <el-collapse-item title="隐患整改延期" name="postpone" v-if="showPostpone">
            <HiddenPostponeView :FormData="formData"></HiddenPostponeView>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <!-- todo进行判断加入按钮 -->
        <template v-if="formData.hiddenDangerRectificationStatus === 0">
          <el-button type="primary" size="small" @click="startRectification" :loading="loading"
            >开始整改</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="showDialog = true"
            :loading="loading"
            v-if="formData.hiddenDangerRectificationStatus === 0"
            >驳回</el-button
          >
        </template>
        <!-- 整改中或从待办过来的旧状态数据 -->
        <template
          v-if="
            formData.hiddenDangerRectificationStatus === 1 ||
              formData.hiddenDangerRectificationStatus === 3 ||
              (istodo && !isdelay && formData.hiddenDangerRectificationStatus === 4)
          "
        >
          <el-button type="primary" size="small" @click="submitForm" :loading="loading"
            >申请验收</el-button
          >

          <!-- 延期状态进来的不显示延期按钮，选中了立即执行的不显示延期按钮 -->
          <el-button
            v-if="formData.hiddenDangerRectificationStatus === 1 && !formData.isCheckCorrect"
            type="primary"
            size="small"
            @click="showDelayForm = true"
            :loading="loading"
            >申请延期</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="showDialog = true"
            :loading="loading"
            v-if="formData.hiddenDangerRectificationStatus !== 4"
            >驳回</el-button
          >
        </template>

        <!-- <template v-if="formData.hiddenDangerRectificationStatus === 3">
          <el-button type="primary" size="small" @click="showDelayForm = true" :loading="loading"
            >延期整改</el-button
          >
        </template> -->

        <template
          v-if="(!istodo && formData.hiddenDangerRectificationStatus === 4) || (istodo && isdelay)"
        >
          <el-button type="primary" size="small" @click="handleAudit(true)" :loading="loading"
            >延期通过</el-button
          >
          <el-button type="primary" size="small" @click="handleAudit(false)" :loading="loading"
            >延期驳回</el-button
          >
        </template>

        <el-button @click="goBack" size="small">取消</el-button>
      </div>
    </div>
    <!-- 延期驳回 -->
    <HiddenRejectDialog
      title="延期驳回"
      v-if="showPostponeDialog"
      @handleOk="handlePostponeRejectOk"
      @cancel="showPostponeDialog = false"
    ></HiddenRejectDialog>
    <!-- 驳回 -->
    <HiddenRejectDialog
      v-if="showDialog"
      @handleOk="handleRejectOk"
      @cancel="showDialog = false"
    ></HiddenRejectDialog>
    <RectificationForm
      v-if="showForm"
      ref="rectificationForm"
      :id="formData.id"
      :propsFormData="formData"
      @handleOk="handleFormOk"
      @cancel="showForm = false"
    ></RectificationForm>
    <DelayForm
      v-if="showDelayForm"
      :FormData="formData"
      @handleOk="handleDelayFormOk"
      @cancel="showDelayForm = false"
    ></DelayForm>
  </el-card>
</template>

<script>
import uuid from 'uuid'

import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import HiddenInfo from '../business/HiddenInfo'
import HiddenOk from '../business/HiddenOk'
import HiddenPostponeView from '../business/HiddenPostponeView'
import HiddenRejectDialog from '../business/HiddenRejectDialog'
import RectificationForm from './RectificationForm'
import DelayForm from './DelayForm'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

const areaApi = new AreaApi()

export default {
  name: 'hidden-rectification-form',
  components: {
    HiddenOk,
    HiddenInfo,
    HiddenPostponeView,
    HiddenRejectDialog,
    RectificationForm,
    DelayForm,
    FormUpload,
    ImgUpload,
    MultiplePersonSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      showDelayForm: false,
      showForm: false,
      showDialog: false,
      showPostponeDialog: false,
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      riskLevelList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo', 'verify', 'rectification', 'postpone'],
    }
  },
  watch: {},
  computed: {
    disabled() {
      // 隐患整改只能在整改中的状态能编辑
      // return !(this.formData.hiddenDangerRectificationStatus === 1)
      return !(
        [1, 3].includes(this.formData.hiddenDangerRectificationStatus) ||
        (this.istodo && !this.isdelay && this.formData.hiddenDangerRectificationStatus === 4)
      )
    },
    showPostpone() {
      return (
        this.formData.hiddenDangerRectificationExtensionApplicantId ||
        this.formData.hiddenDangerRectificationExtensionApplicationTime ||
        this.formData.deferralTime ||
        this.formData.hiddenDangersRectificationDelayReason
      )
    },
    // 判断是不是待办过来的
    istodo() {
      return this.$route.query.id && this.$route.query.mode
    },
    // 判断是不是延期审核
    isdelay() {
      return this.$route.query.isdelay === '1'
    },
  },
  created() {
    this.getData()
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
      ],
      ['hiddenLevelList', 'hiddenTypeList', 'hiddenCategoryList'],
      this
    )
    console.log(this.FormData, '123')
  },
  mounted() {},

  methods: {
    async getData() {
      this.formData = JSON.parse(JSON.stringify(this.FormData))
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    goBack() {
      this.$emit('cancel')
    },
    handleDelayFormOk() {
      this.$emit('refreshList')
      this.$emit('cancel')
    },
    async handleFormOk() {
      this.$emit('refreshList')
      this.$emit('cancel')
      const [err, res] = await hiddenDangerRectificationChecklistApi.get(this.formData.id)
      this.formData = { ...this.formData, ...res }
      this.showForm = false
    },
    async handleRejectOk(reason) {
      // 驳回
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationOverrule({
        body: {
          id: this.formData.id,
          currentWorkflowTaskId: this.formData.currentWorkflowTaskId,
          rejectionReasons: reason,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '驳回成功',
          type: 'success',
        })
        this.$emit('refreshList')
        this.$emit('cancel')
      }
      this.showDialog = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    async handleAudit(ispass) {
      // 延期审核  hiddenDangersRectificationPostponeOverrule
      if (!ispass) {
        this.showPostponeDialog = true
      } else {
        this.loading = true
        const [
          err,
          res,
        ] = await hiddenDangerRectificationChecklistApi.hiddenDangersVerificationPostponeAudit({
          id: this.formData.id,
          currentWorkflowDelayTaskId: this.formData.currentWorkflowDelayTaskId,
        })
        this.loading = false
        if (!err) {
          this.$message({
            showClose: true,
            message: '审核成功',
            type: 'success',
          })
          this.$emit('refreshList')
          this.$emit('cancel')
        }
      }
    },
    async handlePostponeRejectOk(reason) {
      // 延期驳回
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationPostponeOverrule({
        body: {
          id: this.formData.id,
          currentWorkflowTaskId: this.formData.currentWorkflowDelayTaskId,
          rejectionReasons: reason,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '驳回成功',
          type: 'success',
        })
        this.$emit('refreshList')
        this.$emit('cancel')
      }
      this.showPostponeDialog = false
    },
    startRectification() {
      if (
        dayjs().format('YYYY-MM-DD HH:mm:ss') >
        dayjs(this.formData.hiddenDangerRectificationPeriod).format('YYYY-MM-DD HH:mm:ss')
      ) {
        this.$confirm('整改时间已超期是否确定开始整改', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          setTimeout(() => {
            this.showForm = true
            const rectificationForm = this.$refs.rectificationForm
            rectificationForm.$set(
              rectificationForm.formData,
              'hiddenDangerOpinionsRectification',
              this.formData.hiddenDangerVerifierOpinions
            )
          }, 300)
        })
      } else {
        this.showForm = true
        this.$nextTick(() => {
          const rectificationForm = this.$refs.rectificationForm
          rectificationForm.$set(
            rectificationForm.formData,
            'hiddenDangerOpinionsRectification',
            this.formData.hiddenDangerVerifierOpinions
          )
        })
      }
    },
    submitForm() {
      // hiddenDangerRectificationPeriod 隐患整改限期 判断是否能提交整改
      // if (
      //   dayjs().format('YYYY-MM-DD HH:mm:ss') >
      //   dayjs(this.formData.hiddenDangerRectificationPeriod).format('YYYY-MM-DD HH:mm:ss')
      // ) {
      //   this.$message.warning('超期未整改,请延期成功后操作!')
      //   return
      // }
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          // this.formData = utils.dealTimeField(this.formData)
          if (this.formData.startRectificationTime) {
            this.formData.startRectificationTime = dayjs(
              this.formData.startRectificationTime
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          this.loading = true
          // return
          const [
            err,
            res,
          ] = await hiddenDangerRectificationChecklistApi.hiddenDangersVerificationAudit({
            id: this.formData.id,
            body: this.formData,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '申请验收成功',
              type: 'success',
            })
            this.$emit('refreshList')
            this.$emit('cancel')
          }
          this.loading = false
        }
        // 验证不通过定位到第一个错误的地方
        const keyList = Object.keys(object)
        if (keyList && keyList.length) {
          const el = this.$refs[keyList[0]].$el
          el.scrollIntoView(true)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
